import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'

const FreeReign = (props) => {
  const { html, id } = props
  return (
    <Typography
      id={id}
      component="div"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}

FreeReign.propTypes = {
  html: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
}

export default FreeReign



// WEBPACK FOOTER //
// ./src/components/Landing/FreeReign/index.js